import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReplaceunderscorePipe } from './replaceunderscore.pipe'
import { TemplateRefPipe } from './template-ref.pipe'
import { TransformDateTimePipe } from './transform-date-time.pipe'

@NgModule({
  declarations: [ReplaceunderscorePipe, TemplateRefPipe, TransformDateTimePipe],
  imports: [CommonModule],
  exports: [ReplaceunderscorePipe, TemplateRefPipe, TransformDateTimePipe],
})
export class PipesModule {}
